// Returns the URL we should use for playback. CDN/S3 is preferred because
// raw drive.google.com /view links are HTML pages, not video streams.
export const getPlayableAssetUrl = (deliveryOrItem) =>
  (deliveryOrItem?.s3_asset_url || "").trim() ||
  (deliveryOrItem?.ad_asset_url || "").trim();
